<script
  setup
  lang="ts"
  generic="
    ListingFilter extends {
      code: string;
      label: string;
      name: string;
      options: Array<Schemas['PropertyGroupOption']>;
      entities: Array<Schemas['ProductManufacturer']>;
    }
  "
>
import { inject, ref } from "vue";
import { getTranslatedProperty } from "@shopware/helpers";
import type { Schemas } from "#shopware";

const props = defineProps<{
  filter: ListingFilter;
}>();

const emits = defineEmits<{
  (e: "select-value", value: { code: string; value: unknown }): void;
}>();
const selectedOptionIds = inject<string[]>("selectedOptionIds");
const isFilterVisible = ref<boolean>(false);
const toggle = () => {
  isFilterVisible.value = !isFilterVisible.value;
};
</script>

<template>
  <div>
    <h5 class="mb-[10px] md:mb-4 normal-case flex items-center justify-between">
      {{ props.filter.label }}
    </h5>
    <template v-if="props.filter.displayType === 'color'">
      <div
        :id="props.filter.code"
        class="flex flex-wrap gap-2 md:gap-[10px] color-box-wrap"
      >
        <div
          v-for="option in props.filter.options || props.filter.entities"
          :key="`${option.id}-${selectedOptionIds?.includes(option.id)}`"
          class="w-9 md:w-12"
        >
          <input
            type="checkbox"
            class="absolute"
            :id="`filter-mobile-${props.filter.code}-${option.id}`"
            :checked="selectedOptionIds?.includes(option.id)"
            :name="props.filter.name"
            :value="option.name"
            :aria-label="`${option.name} filter`"
            @change="
              emits('select-value', {
                code: props.filter.code,
                value: option.id,
              })
            "
          />
          <label
            v-if="!option.media"
            class="aspect-square border border-solid border-black03 bg-pink block relative before:border-pink"
            :for="`filter-mobile-${props.filter.code}-${option.id}`"
            :style="'background:' + option.colorHexCode"
          >
          </label>
          <label
            v-if="option.media"
            class="aspect-square border border-solid border-black03 bg-pink block relative before:border-pink"
            :for="`filter-mobile-${props.filter.code}-${option.id}`"
          >
            <NuxtImg loading="lazy" format="webp" :src="option.media.url" />
          </label>
        </div>
      </div>
    </template>

    <template
      v-else-if="props.filter.id === 'f75664f83fafa32267370c7d4ac0d7f0'"
    >
      <div
        :id="props.filter.code"
        class="flex flex-wrap gap-2 md:gap-[10px] color-box-wrap"
      >
        <div
          v-for="option in props.filter.options || props.filter.entities"
          :key="`${option.id}-${selectedOptionIds?.includes(option.id)}`"
          class="w-9 md:w-12"
        >
          <input
            type="checkbox"
            class="absolute opacity-0"
            :id="`filter-mobile-${props.filter.code}-${option.id}`"
            :checked="selectedOptionIds?.includes(option.id)"
            :name="props.filter.name"
            :value="option.name"
            :aria-label="`${option.name} filter`"
            @change="
              emits('select-value', {
                code: props.filter.code,
                value: option.id,
              })
            "
          />
          <label
            class="aspect-square border border-solid border-black03 relative before:border-pink flex items-center justify-center"
            :for="`filter-mobile-${props.filter.code}-${option.id}`"
            >{{ option.name }}</label
          >
        </div>
      </div>
    </template>

    <template v-else>
      <ul :id="props.filter.code" class="flex flex-col gap-[6px] md:gap-[10px]">
        <li
          v-for="option in props.filter.options || props.filter.entities"
          :key="`${option.id}-${selectedOptionIds?.includes(option.id)}`"
        >
          <input
            type="checkbox"
            class="absolute opacity-0"
            :id="`filter-mobile-${props.filter.code}-${option.id}`"
            :checked="selectedOptionIds?.includes(option.id)"
            :name="props.filter.name"
            :value="option.name"
            :aria-label="`${option.name} filter`"
            @change="
              emits('select-value', {
                code: props.filter.code,
                value: option.id,
              })
            "
          />
          <label
            class="cust_check font-semibold"
            :for="`filter-mobile-${props.filter.code}-${option.id}`"
            >{{ option.name }}</label
          >
        </li>
      </ul>
    </template>

    <!--div :id="props.filter.code" class="pt-6">
        <fieldset class="space-y-4">
          <legend class="sr-only">{{ props.filter.name }}</legend>
          <div
            v-for="option in props.filter.options || props.filter.entities"
            :key="`${option.id}-${selectedOptionIds?.includes(option.id)}`"
            class="flex items-center"
          >
            <input
              :id="`filter-mobile-${props.filter.code}-${option.id}`"
              :checked="selectedOptionIds?.includes(option.id)"
              :name="props.filter.name"
              :value="option.name"
              :aria-label="`${option.name} filter`"
              type="checkbox"
              class="h-4 w-4 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500"
              @change="
                emits('select-value', {
                  code: props.filter.code,
                  value: option.id,
                })
              "
            />

            <div v-if="option.media?.url">
              <img
                loading="lazy"
                class="ml-2 h-4 w-4"
                :src="option.media.url"
                :alt="option.media.translated.alt || ''"
                :class="{
                  'border-blue border-2': selectedOptionIds?.includes(
                    option.id,
                  ),
                }"
              />
            </div>
            <div
              v-else-if="option.colorHexCode"
              class="ml-2 h-4 w-4"
              :style="`background-color: ${option.colorHexCode}`"
              :class="{
                'border-blue border-2': selectedOptionIds?.includes(option.id),
              }"
            />
            <label
              :for="`filter-mobile-${props.filter.code}-${option.id}`"
              class="ml-3 text-gray-600"
            >
              {{ getTranslatedProperty(option, "name") }}
            </label>
          </div>
        </fieldset>
      </div-->
  </div>
</template>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
